import { PaginationProps } from "@/types/components/pagination/pagination";
import { Icon } from "@iconify/react";
import { Link, usePage } from "@inertiajs/react";
import { Fragment } from "react";

const Pagination = ({ links, className = '', preserveScroll = false }: PaginationProps) => {
    const pageParams = usePage();
    let queryString = (pageParams.props.ziggy as { query: { [key: string]: string } }).query;
    delete queryString.page;

    const resolveActiveClass = (active: boolean): string => {
        if (active) {
            return "block mr-2 [&>span]:text-primary font-extrabold text-p leading-p";
        } else {
            return "block mr-2 font-extrabold text-p leading-p";
        }
    };

    if (links.length > 3) {
        return (
            <div className={`flex flex-wrap my-12 maxMd:my-8 items-center ${className}`}>
                {links.map((link, id) => {
                    if (link.label === "...") {
                        return (
                            <div key={id} className="w-3 h-1"></div>
                        );
                    }
                    if (link.url !== null) {
                        if (link.label === "Next &raquo;") {
                            return (
                                <Link data={{...queryString}} preserveScroll={preserveScroll} key="next-btn" href={link.url} title="Dalej">
                                    <Icon
                                        width={30}
                                        height={25}
                                        rotate={2}
                                        className="text-secondary"
                                        icon="material-symbols:arrow-back-ios-new-rounded"
                                    />
                                </Link>
                            );
                        }

                        if (link.label === "&laquo; Previous") {
                            return (
                                <Link data={{...queryString}} preserveScroll={preserveScroll} key="prev-btn" href={link.url} title="Dalej">
                                    <Icon
                                        width={30}
                                        height={25}
                                        className="text-secondary mr-2"
                                        icon="material-symbols:arrow-back-ios-new-rounded"
                                    />
                                </Link>
                            );
                        }

                        return (
                            <Link data={{...queryString}} preserveScroll={preserveScroll}
                                key={id}
                                href={link.url}
                                title={`Strona - ${link.label}`}
                                className={resolveActiveClass(link.active)}
                            >
                                <span className="text-18 font-bold text-secondary">
                                    {link.label}
                                </span>
                            </Link>
                        );
                    }
                    return null;
                })}
            </div>
        );
    }
    return null;
};

export default Pagination;